function ScrollProgress() {
  return (
    <div className="fixed right-3 top-32 z-[60] hidden h-[calc(100vh-9rem)] w-1 overflow-hidden rounded-full bg-ink/10 dark:bg-pale/15 sm:block" aria-hidden="true">
      <span className="block rounded-full bg-brand-gold shadow-glow [height:calc(var(--scroll-progress,0)*100%)]" />
    </div>
  );
}

export default ScrollProgress;
